var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RemotePaginatedList',_vm._b({attrs:{"filter-options":_vm.filterOptions,"headers":_vm.headers,"multi-sort":"","data-url":"payment/admin/payment_record/","data-key":"records","extra-params":{'user_id': _vm.userId}},scopedSlots:_vm._u([{key:"item.create_at",fn:function(ref){
var value = ref.value;
return [_vm._v("\n    "+_vm._s(_vm.$parseDate(value))+"\n  ")]}},{key:"item.payment_type",fn:function(ref){
var value = ref.value;
return [_vm._v("\n    "+_vm._s(_vm.$t(("payment_type." + value)))+"\n  ")]}},{key:"item.payment_method",fn:function(ref){
var value = ref.value;
return [_vm._v("\n    "+_vm._s(_vm.$t(("payment_method." + value)))+"\n  ")]}},{key:"item.ref_no",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.$getPaymentRecordRefNo(item))+"\n  ")]}},{key:"item.card_no",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.$getPaymentRecordCardNo(item))+"\n  ")]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.$getPaymentRecordTotal(item))+"\n  ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.$getPaymentRecordStatus(item))+"\n  ")]}}])},'RemotePaginatedList',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }